var $29700c92185d38f8$exports = {};
$29700c92185d38f8$exports = {
    "dismiss": `Kapat`
};


export {$29700c92185d38f8$exports as default};
//# sourceMappingURL=tr-TR.module.js.map
